/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web1920105.css";

function Web1920105(props) {
  const { x50173806488_38F6267B2A_5K, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-105 screen">
        <div className="overlap-group1-18">
          <img className="x50173806488_38f6267b2a_5k-1" src={x50173806488_38F6267B2A_5K} />
          <div className="overlap-group-35">
            <div className="group-141-8">
              <div className="group-140-8">
                <div className="group-139-8">
                  <img className="group-138-8" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-8" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web1920105;
